import React, { useState } from "react";
import "./numpad.css";
import {
    snpAxios } from "../../global/api";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { useDispatch,
    useSelector } from "react-redux";
import { addCachedBillProductDetails,
    addItemToBill,
    updateBillItem } from "../../../store/billDetailsSlice";
import { recalculateBillTotal } from "../../../store/thunk/billCalculatorThunk";
import {
  getPreUrlAccordingToCart,
  isEmpty,
  isRoleAllowed,
  printDebugLog,
  SUCCESS,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS,
  OTHER_TABLE_OWNER_RIGHTS,
  ROLE_CREATE,
  BILLMGMT,
  ONLINEBILLMGMT
} from "../../../constants/constant";

// Take a look at imports if missing add those
const NumpadItemSearch = ({ callHide }) => {
  const [value, setValue] = useState("");
  const { loader, snackbar } = useSnpUI();
  const dispatch = useDispatch();

  const storeActiveShopHash = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash
  );
  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
  );

  const storeProductData = useSelector(
    (state) => state.setProductWithCatgReducer.productData
  );

  const {
    billItems,
    billDetails
  } = useSelector((state) => state.bill);

  const keys = [
    ["1", "2", "3"],
    ["4", "5", "6"],
    ["7", "8", "9"],
    ["⏎", "0", "⌫"],
  ];

  const getCachedProduct = async (catgId) => {
    const cached = storeProductData?.[catgId];
    return cached;
  }

  const getMwnuItemByNum = async (num, responseCallback) => {
    try {
      const url =
        `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-rate-card-serial-no?s=${storeActiveShopHash.id}&q=${num}`
      loader.show();
      const response = await snpAxios.get(url);
      if (response.data.status === SUCCESS) {
        loader.hide();
        const item = response.data.jcJson;
        console.log("item fetched from db...", item);
        responseCallback(item);
        return;
      }

    } catch (e) {
      //toast.error("Error!");
      printDebugLog("Error in fetch item by num ", e);
    }
    loader.hide();
    responseCallback(null);
  };


  const getProductName = (data) => {
    let name = data.name;
    if (!isEmpty(data.price.name)) name = name + "(" + data.price.name + ")";
    return name;
  };

  const handleAddItem = (itemNum) => {
    // local check
    getMwnuItemByNum(itemNum, (data) => {
      if (!data) {
        return;
      }

      if (billDetails.isPaid) {
        snackbar.show({
          message: "Can't add item to paid bill",
          color: "red",
        });
        //onClose(); To be passed  or removed if not needed
      } else if (
        isOtherRoleAllowed(OTHER_TABLE_OWNER_RIGHTS) ||
        isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE) ||
        isOtherRoleAllowed(OTHER_ADMIN_RIGHTS)
      ) {
        //  ;
        printDebugLog("handleAddItem", data);
        const transFormedBillItem = {
          ...data,
          prdId: data.id ? data.id : data.prdId,
          price: data.price.sAmt,
        };
        console.log("billItems: " + billItems);
        const item = billItems.find(
          (item) => item.prdId === transFormedBillItem.prdId
        );
        console.log("item: " + JSON.stringify(item));
        if (item) {
          dispatch(
            updateBillItem({
              ...item,
              quantity: item.quantity + 1,
              finalPrice: Number(item.price) * (Number(item.quantity) + 1),
            })
          );
          snackbar.show({
            message:
              item.quantity +
              1 +
              "* " +
              getProductName(data) +
              " added successfully",
            color: "green",
            vertical: "top",
            horizontal: "right",
          });
        } else {
          // ;
          dispatch(
            addItemToBill({
              ...transFormedBillItem,
              name: getProductName(data),
              quantity: 1,
              combo: data.catgId === "snp_combo_id",
              finalPrice: Number(data.price.sAmt) * 1,
            })
          );
          snackbar.show({
            message: "1 * " + getProductName(data) + " added successfully",
            color: "green",
            vertical: "top",
            horizontal: "right",
          });
          //console.log("ftg: ", products);
          console.log("data: ", data);
          // const product = products.find(
          //   (prd) =>
          //     transFormedBillItem.prdId === prd.id ||
          //     transFormedBillItem.id === prd.id
          // );
          // console.log("selectedProduct: ", product);
          // if (product) {
          //   dispatch(addCachedBillProductDetails(product));
          // }
        }
        //   if (!isMultiSelectEnabled) {
        //     onClose();
        //   }
        dispatch(
          recalculateBillTotal({
            prevTotalPrice: 0,
            newTotalPrice: data.price.sAmt,
            cgstRate: data.cgst,
            sgstRate: data.sgst,
          })
        );
      } else {
        snackbar.show({
          message: "You are not allowed to add items! Contact Admin",
          color: "red",
        });
      }
      callHide && callHide();
    });

  };


  const handleButtonClick = (key) => {
    if (key === "⏎") {
      handleAddItem(value);
    } else if (key === "⌫") {
      setValue((prev) => prev.slice(0, -1));
    } else if (key !== "") {
      setValue((prev) => prev + key);
    }
    // Vibration for mobile
    if (navigator.vibrate) {
      navigator.vibrate(25);
    }
  };


  return (
    <div className="numpad-container">
      <input
        className="input-field"
        type="text"
        value={value}
        readOnly
        placeholder="Enter number"
      />

      <div className="numpad">
        {keys.flat().map((key, index) =>
          key ? (
            <button
              key={index}
              className="key-button"
              onClick={() => handleButtonClick(key)}
            >
              {key}
            </button>
          ) : (
            <div key={index} className="empty-key"></div>
          )
        )}
      </div>
    </div>
  );
}

export default NumpadItemSearch;
